import { render, staticRenderFns } from "./newPhoneBuyPrice.vue?vue&type=template&id=9fa42a72&scoped=true&"
import script from "./newPhoneBuyPrice.vue?vue&type=script&lang=js&"
export * from "./newPhoneBuyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa42a72",
  null
  
)

export default component.exports